/** predefinedQuestions 배열에서 「생활불편 신고」카드 인덱스 (ko 기준) */
export const LIFE_INCONVENIENCE_PREDEFINED_QUESTION_INDEX = 4;

/** 클릭 시 menuItems처럼 해당 문구를 바로 질문으로 전송하는 카드 */
export function isLifeInconvenienceAskCard(text: string): boolean {
  const s = (text || '').toLowerCase().replace(/\s+/g, '');
  if (!s) return false;
  return [
    '생활불편신고',
    '생활불편',
    'lifeinconvenience',
    'inconveniencereport',
    '生活不便',
  ].some((k) => s.includes(k));
}
